<template>
  <v-dialog
  v-model="isDialogOpen"
  persistent
  max-width="640">
    <v-card>
      <v-toolbar color="white" flat>
          <v-toolbar-title>{{isEdit ? 'Editar negocio':'Agregar negocio'}}</v-toolbar-title>
          <template v-slot:extension>
            <v-tabs
              style="width: 100%;"
              v-model="tab"
              fixed-tabs
              bg-color="#ffffff">
              <v-tab value="general">
                Generales</v-tab>
              <v-tab value="description">
                Descripción</v-tab>
              <v-tab value="adress">
                Domicilio</v-tab>
              <v-tab value="billing">
                Facturación</v-tab>
            </v-tabs>
          </template>
      </v-toolbar>

      <v-card-text>
        <v-tabs-window v-model="tab">

          <v-tabs-window-item value="general">
            <div class="container-form">

              <div class="div-row-form" style="margin: 20PX;">
                <div class="container-input-image" @click="selectFile">
                    <img :src="imageUrl" class="img-selected-form" />
                    <!--
                    <div class="button-add-img" @click="selectFile">
                      <v-icon color="white" size="x-large">mdi-plus</v-icon>
                    </div>
                    -->
                    <span class="title-add-img">Logo</span>
                    <input type="file"
                      ref="fileInput"
                      @change="onFileChange"
                      accept="image/*"
                      style="display: none;"/>
                </div>
              </div>

              <div class="div-row-form">
                <v-text-field
                  width="50%"
                  label="Nombre del negocio"
                  placeholder="Nombre del negocio"
                  v-model="business.name"
                  color="#222222"
                  variant="underlined"
                  type="text"
                  :rules="rules.required"/>

                <div class="space-element"/>

                <v-select
                  width="50%"
                  label="Seleccionar categoría"
                  v-model="business.category"
                  :items="itemsCategory"
                  :rules="rules.required"
                  variant="underlined"/>
              </div>
            </div>

          </v-tabs-window-item>

          <v-tabs-window-item value="description">
            <div class="container-form">
              <v-textarea
                v-model="business.description"
                label="Descripción del evento o negocio"
                color="#222222"
                placeholder="Descripción del evento o negocio"
                variant="underlined"
                auto-grow
                :rules="rules.required"/>
            </div>
          </v-tabs-window-item>

          <v-tabs-window-item value="adress">
            <div class="container-form">
              <v-text-field
                label="Domicilio"
                placeholder="Domicilio"
                v-model="business.address"
                color="#222222"
                variant="underlined"
                type="text"
                :rules="rules.required"/>

                <div class="div-row-form">
                  <v-text-field
                    width="50%"
                    label="Código postal"
                    placeholder="Código postal"
                    v-model="business.postal_code"
                    color="#222222"
                    variant="underlined"
                    type="text"
                    :rules="rules.required"/>
                  <div class="space-element"/>
                  <v-text-field
                    width="50%"
                    label="Ciudad"
                    placeholder="Ciudad"
                    v-model="business.city"
                    color="#222222"
                    variant="underlined"
                    type="text"
                    :rules="rules.required"/>
                </div>

                <div class="div-row-form">
                  <v-text-field
                    width="50%"
                    label="Estado"
                    placeholder="Estado"
                    v-model="business.state"
                    color="#222222"
                    variant="underlined"
                    type="text"
                    :rules="rules.required"/>
                  <div class="space-element"/>
                  <v-text-field
                    width="50%"
                    label="País"
                    placeholder="País"
                    v-model="business.country"
                    color="#222222"
                    variant="underlined"
                    type="text"
                    :rules="rules.required"/>
                </div>
            </div>
          </v-tabs-window-item>

          <v-tabs-window-item value="billing">
            <div class="container-form">
              <div class="div-row-form">
                <v-text-field
                  width="50%"
                  label="Razón social"
                  placeholder="Razón social"
                  v-model="business.legal_entity"
                  color="#222222"
                  variant="underlined"
                  type="text"
                  :rules="rules.required"/>
                <div class="space-element"/>
                <v-text-field
                  width="50%"
                  label="Clave de negocio"
                  placeholder="Clave de negocio"
                  v-model="business.business_key"
                  color="#222222"
                  variant="underlined"
                  type="text"
                  maxlength="3"
                  :rules="rules.required"/>
              </div>
              <div class="div-row-form">
                <v-text-field
                  width="50%"
                  label="RFC"
                  placeholder="RFC"
                  v-model="business.rfc"
                  color="#222222"
                  variant="underlined"
                  type="text"
                  :rules="rules.required"/>
                <div class="space-element"/>
                <v-select
                  width="50%"
                  label="Uso de CFDI"
                  v-model="business.invoice_usage"
                  :items="itemsInvoiceUsage"
                  variant="underlined"
                  :rules="rules.required"/>
              </div>

              <v-text-field
                label="Domicilio fiscal"
                placeholder="Domicilio fiscal"
                v-model="business.tax_residence"
                color="#222222"
                variant="underlined"
                type="text"
                :rules="rules.required"/>

              <v-text-field
                label="Email de facturación"
                placeholder="Email de facturación"
                v-model="business.invoice_email"
                color="#222222"
                variant="underlined"
                type="text"
                :rules="rules.validEmail"/>

            </div>
          </v-tabs-window-item>

        </v-tabs-window>
      </v-card-text>

      <v-card-actions>
        <v-btn
          class="btn-cancel-form"
          color="#6E6E6E"
          variant="text"
          rounded="xl"
          @click="isDialogOpen = false">
          Cancelar
        </v-btn>

        <v-btn
          class="btn-action-form"
          rounded="xl"
          color="#FFFFFF"
          :loading="isSavingData"
          :disabled="disableBtn()"
          @click="actionBtn">
          {{tab === 'billing' ? 'Guardar': 'Siguiente' }}
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import businessApi from '@/api/businessApi'
export default {
  name: 'CommerciaVueAddEditBusiness',
  emits: ['refreshList'],
  data () {
    return {
      imageData: null,
      imageUrl: require('../../assets/imgs/svgs/upload-img.svg'),

      validData: true,
      isSavingData: false,
      isDialogOpen: false,
      isEdit: false,
      tab: null,
      itemsCategory: [
        'Arena',
        'Centro Comercial',
        'Centro de Convenciones',
        'Centro de Espectáculos',
        'Estadio',
        'Feria',
        'Hacienda Turística',
        'Museo Interactivo',
        'Parque Acuático',
        'Parque de Atracciones',
        'Parque Turístico',
        'Zoológico'
      ],
      itemsInvoiceUsage: [
        'Gastos en general'
      ],

      business: this.initObj(),

      rules: {
        required: [
          v => !!v || 'Campo requerido.'
        ],
        validEmail: [
          (v) => !!v || 'Campo requerido.',
          (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) || 'Email no válido'
        ]
      }
    }
  },
  methods: {
    initObj () {
      return {
        category: null,
        active: null,
        address: null,
        city: null,
        country: null,
        created_at: null,
        description: null,
        invoice_email: null,
        invoice_usage: null,
        legal_entity: null,
        name: null,
        postal_code: null,
        rfc: null,
        state: null,
        tax_residence: null,
        updated_at: null,
        _id: null,
        business_key: null
      }
    },
    add () {
      this.business = this.initObj()
      this.imageUrl = require('../../assets/imgs/svgs/upload-img.svg')
      this.business._id = '-'
      this.business.updated_at = Date.now()
      this.business.created_at = Date.now()
      this.business.active = true
      this.isDialogOpen = true
      this.isEdit = false
    },
    edit (business) {
      this.isDialogOpen = true
      this.isEdit = true
      this.business = structuredClone(business)
      this.imageUrl = business.img || require('../../assets/imgs/svgs/upload-img.svg')
    },
    disableBtn () {
      return this.tab === 'billing' &&
      (Object.values(this.business).some(value => value === null || value === '') ||
      !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(this.business.invoice_email))
    },
    actionBtn () {
      switch (this.tab) {
        case 'general':
          this.tab = 'description'
          break
        case 'description':
          this.tab = 'adress'
          break
        case 'adress':
          this.tab = 'billing'
          break
        case 'billing':
          this.isSavingData = true
          if (this.isEdit) {
            this.editBusiness()
          } else {
            this.addBusiness()
          }
          break
        default: break
      }
    },
    async addBusiness () {
      if (await businessApi.add(this.business, this.imageData)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
        // mostar el error
      }
    },
    async editBusiness () {
      if (await businessApi.edit(this.business, this.imageData)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
        // mostar el error
      }
    },
    selectFile () {
      this.$refs.fileInput.click()
    },
    onFileChange (event) {
      const file = event.target.files[0] // Obtiene el archivo seleccionado
      if (file && file.type.startsWith('image/')) {
        this.imageData = file
        this.imageUrl = URL.createObjectURL(file) // Crea una URL de la imagen para vista previa
      } else {
        alert('Por favor selecciona un archivo de imagen válido.')
      }
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/forms.css';
</style>
